import React from "react";
import SectionShell from "./SectionShell";

const POST_EMBED = "https://www.linkedin.com/embed/feed/update/urn:li:share:7100185070916833280";
const POST_URL = "https://www.linkedin.com/feed/update/urn:li:share:7100185070916833280";

export default function Mindset() {
  return (
    <SectionShell id="mindset" eyebrow="From Biagio" data-testid="mindset">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
        <div className="lg:col-span-6 lg:sticky lg:top-28">
          <h2 className="font-display text-[#0B1F3F] text-4xl sm:text-5xl tracking-tight leading-[1.08]">
            What's your <span className="italic text-[#8A6A2E]">excuse?</span>
          </h2>
          <p className="text-[#0F1B2D] text-lg leading-relaxed mt-6 max-w-xl">
            I love a good underdog story. Muggsy Bogues played in the NBA at
            5'3". He was told he'd never make it, and he made it anyway,
            because what he told himself was stronger than anything anyone
            else could say.
          </p>
          <p className="text-[#5A6476] text-base leading-relaxed mt-5 max-w-xl">
            Surround yourself with people who lift you up. It's still going to
            be hard and you still need to do the work, but never let the fear
            of losing keep you from your dreams. Expect to fail, expect to win,
            and keep moving forward.
          </p>
          <blockquote
            className="mt-10 pt-8 border-t border-[#E6E2D8] font-display italic text-[#0B1F3F] text-2xl leading-snug max-w-xl"
            data-testid="mindset-quote"
          >
            "The only person standing in the way of what you want is you, and
            the only words that will ever matter are the ones you speak to
            yourself."
          </blockquote>
          <a
            href={POST_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-secondary mt-6"
            data-testid="mindset-linkedin-link"
          >
            Read the post on LinkedIn
          </a>
        </div>

        <div className="lg:col-span-6 flex justify-center lg:justify-end">
          <div className="w-full max-w-[504px] rounded-2xl overflow-hidden bg-white border border-[#E6E2D8] shadow-[0_30px_60px_-30px_rgba(11,31,63,0.2)]">
            <iframe
              src={POST_EMBED}
              title="Biagio DiGirolamo on LinkedIn: What's your excuse?"
              className="block w-full h-[1250px] sm:h-[1111px]"
              style={{ border: 0 }}
              loading="lazy"
              allowFullScreen
              data-testid="mindset-linkedin-iframe"
            />
          </div>
        </div>
      </div>
    </SectionShell>
  );
}
